const colors  = {

    background: {
        default: "#0c0225",
        card: "#ffffff",
      },

}

export default colors;